<template>
  <b-overlay
    :show="loading"
    class="row bg-white"
  >
    <div class="col-12 mt-3">
      ¿Estás seguro de que quieres aprobar el Lote Nº {{ batch.folio }}?
    </div>
    <div class="col-12 mt-3">
      <b-form
        id="form-message"
        data-vv-scope="form-message"
      >
        <b-row>
          <b-col cols="12">
            <b-form-group
              label="Descripción del lote"
              label-for="#"
            >
              <b-input-group>
                <b-form-textarea
                  rows="4"
                  max
                  maxlength="5000"
                  v-model="description"
                  data-cy="description"
                  data-vv-as="Descripción"
                  id="description"
                  name="description"
                  :state="errors.has('form-message.description') ? false : null"
                  placeholder="Datos adicionales internos"
                />
                <b-form-invalid-feedback>
                  {{ errors.first('form-message.description') }}
                </b-form-invalid-feedback>
              </b-input-group>
            </b-form-group>
          </b-col>
        </b-row>
      </b-form>
    </div>
    <vs-divider></vs-divider>
    <b-col
      cols="12"
      class="text-right"
    >
      <b-button
        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
        type="submit"
        variant="primary"
        v-on:click="onApprove"
        data-cy="approve-batch"
      >
        Si, Estoy seguro!
      </b-button>
    </b-col>
  </b-overlay>
</template>
<script>

import { approveBatch } from '@/febos/servicios/api/aduanas/batches.api';

export default {
  data() {
    return {
      loading: false,
      description: '',
      descriptionFactura: ''
    };
  },
  props: {
    batch: {
      type: Object,
      required: true
    }
  },
  methods: {
    async onApprove() {
      const isValid = await this.$validator.validateAll('form-message');
      if (!isValid) {
        return;
      }
      this.loading = true;
      try {
        await approveBatch({
          loteId: this.batch.loteId,
          description: this.description
        });
        this.$emit('approve');
      } finally {
        this.loading = false;
      }
    }
  },
  async created() {
    this.loading = false;
    this.description = this.batch.descripcionLote;
    this.descriptionFactura = this.batch.descripcionLoteFactura;
  }
};
</script>
